import { Button } from '@akin-home/buttons/native';
import styled from 'styled-components/native';
import SwitchProfileModal from '../../habitat/components/SwitchProfileModal';
import { useMainDrawerNavigaton } from '../../navigation/hooks';
import { useCurrentUser } from '../../users';
import useBool from '../../utils/state/useBool';
import DashboardProfile from '../DashboardProfile/DashboardProfile';

export const DashboardProfilePanel = () => {
  const user = useCurrentUser();
  const { navigate } = useMainDrawerNavigaton();

  const [profilePickerVisible, show_profile_picker, hide_profile_picker] =
    useBool();

  const onPressSettings = () => navigate('Settings');
  const onPressEditHome = () => {
    navigate('EditHomeScreen', { show_back_button: true });
  };

  const onLongPressEditHome = () => {
    // A hidden way to retrigger the onboarding flow
    navigate('Onboarding');
  };

  return (
    <Panel>
      <Container>
        <NameHolder onPress={show_profile_picker}>
          <DashboardProfile user={user} />
        </NameHolder>

        <Button
          variant="secondary"
          onPress={onPressEditHome}
          onLongPress={onLongPressEditHome}
        >
          Edit Home
        </Button>

        <Button
          variant="secondary"
          icon="cog"
          iconSize={20}
          onPress={onPressSettings}
        />
      </Container>

      <SwitchProfileModal
        isVisible={profilePickerVisible}
        onRequestClose={hide_profile_picker}
        onPressSettings={onPressSettings}
      />
    </Panel>
  );
};

const Panel = styled.View`
  flex: 1;
`;

const NameHolder = styled.TouchableOpacity`
  flex: 1;
`;

const Container = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;
